// Displays a dollar amount rounded to the nearest whole dollar, with a
// leading "$" and thousands separators. Underlying stored amounts keep
// full precision — this is a display-only rounding.
export function formatUSD(amount: number): string {
  return `$${Math.round(amount).toLocaleString()}`;
}
